var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeadsetIcon = function SvgHeadsetIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.617 10h-2.5a1.25 1.25 0 0 0-1.25 1.25v3.125a1.25 1.25 0 0 0 1.25 1.25h1.25a1.25 1.25 0 0 0 1.25-1.25zm0 0a7.5 7.5 0 0 0-7.562-7.5A7.5 7.5 0 0 0 2.5 10v4.375a1.25 1.25 0 0 0 1.25 1.25H5a1.25 1.25 0 0 0 1.25-1.25V11.25A1.25 1.25 0 0 0 5 10H2.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.617 14.375v1.875a2.5 2.5 0 0 1-2.5 2.5h-4.492"
  })));
};
export default SvgHeadsetIcon;